import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=f4f454d0&scoped=true&"
import script from "./CouponCard.vue?vue&type=script&lang=js&"
export * from "./CouponCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponCard.vue?vue&type=style&index=0&id=f4f454d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f454d0",
  null
  
)

export default component.exports